module.exports = __webpack_public_path__ + "img/23-1.abdf8f7c.png";